
// Helper function to ensure URLs have proper format
export const formatUrl = (url: string | null): string | null => {
  if (!url) return null;
  if (url.trim() === "") return null;
  
  // Return if already has protocol
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  
  // Add https:// prefix
  return `https://${url}`;
};

// Helper function to create fallback validation
export const createFallbackValidator = () => {
  return async (values: any) => {
    // Basic validation rules
    const errors: Record<string, any> = {};
    
    if (!values.email) {
      errors.email = { message: "Email is required" };
    } else if (!/\S+@\S+\.\S+/.test(values.email)) {
      errors.email = { message: "Invalid email address" };
    }
    
    if (values.newPassword && values.newPassword.length < 6) {
      errors.newPassword = { message: "Password must be at least 6 characters" };
    }
    
    if (values.newPassword && values.newPassword !== values.confirmPassword) {
      errors.confirmPassword = { message: "Passwords do not match" };
    }
    
    return {
      values,
      errors: Object.keys(errors).length ? errors : {}
    };
  };
};
